(ns manatee.models.edit)

(defn item->base-edit
  [{:keys [id account-id deferred? item-type item-task task-config-id] :as _item}]
  {:item-id id
   :account-id account-id
   :item-type item-type
   :item-task item-task
   :task-config-id task-config-id
   :deferred? deferred?})
